import { render } from "./FAQWrapper.vue?vue&type=template&id=d8bd56c0"
import script from "./FAQWrapper.vue?vue&type=script&lang=js"
export * from "./FAQWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__